import { CircleUserRound } from 'lucide-react';
import type { AuditEntry } from '@/services/api/user-audit';

export const AuditEntryArticle = ({ entry }: { entry: AuditEntry }) => (
  // Legacy layout: 40px avatar column, 30px column gap (BopUserAuditList)
  <article className="grid grid-cols-[40px_1fr] gap-[30px]">
    <CircleUserRound aria-hidden className="size-10 text-muted-foreground" />
    <div className="grid gap-1">
      <div className="flex flex-wrap items-baseline gap-1">
        <span className="font-bold">{entry.requester}</span>
        <span>{entry.time}</span>
      </div>
      {/* type !== 'comment' means type IS the note string — the legacy `note || 'Comment'`
          fallback was unreachable, keep the simple form */}
      {entry.type !== 'comment' ? (
        <div>
          <span className="font-bold">Action:</span> {entry.note}
        </div>
      ) : null}
      {/* system rows may lack `comment` — render blanks gracefully */}
      {entry.comment ? <div className="whitespace-pre-wrap">{entry.comment}</div> : null}
    </div>
  </article>
);
AuditEntryArticle.displayName = 'AuditEntryArticle';
